import React, { Children, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Timeline, Tooltip } from 'antd';
import styles from './index.module.less';

export default function FollowRecord ({ basicInfo = [] })  {

  const [logData, setLogData] = useState<Array<any>>([]);

  useEffect(() => {
    const logs = basicInfo?.length ? basicInfo.map((info: any) => {
        return {
          children: (
            <div className={styles.followBox}>
              <div className={styles.followTime}>
                <span style={{ marginRight: 15 }}>{info?.lastUpdatedTime ? dayjs(info?.lastUpdatedTime).format('YYYY-MM-DD HH:mm') : ''}</span>
                <div style={{ marginRight: 10, height: '20px', padding: '0 5px', fontSize: '12px', lineHeight: '20px', backgroundColor: 'rgba(240, 232, 255, 1)', color: 'rgba(136, 81, 237, 1)' }}>{ info.buttonName }</div>
                <div style={{ marginRight: 10, height: '20px', padding: '0 5px', fontSize: '12px', lineHeight: '20px', backgroundColor: 'rgba(255, 240, 217, 1)', color: 'rgba(245, 147, 0, 1)' }}>{ info.followerTypeName }</div>
              </div>
              <div style={{ fontWeight: 400, fontSize: '14px', lineHeight: '22px', marginTop: '10px' }}><span style={{ color: 'rgba(135, 136, 138, 1)' }}>跟进人：</span><span>{ info.name }</span></div>
              <div style={{ fontWeight: 400, fontSize: '14px', lineHeight: '22px', marginTop: '10px' }}><span style={{ color: 'rgba(135, 136, 138, 1)' }}>跟进内容：</span><span>{ info.content }</span></div>
            </div>
          )
        }
      }
    ) : []
    setLogData(logs);
  }, [basicInfo])

  return (
    <div className={styles.followBasicInfoBox}>
      {(basicInfo && basicInfo?.length !== 0) ? <Timeline items={logData} /> : <div>无跟进记录</div>}
    </div>
  )
}